import avatarHtml from './avatar.html';
import {emitMonorailEventThroughTrekkie} from './utils/emitMonorailEventThroughTrekkie';

const ATTRIBUTE_SRC = 'src';
const ATTRIBUTE_INITIAL = 'initial';

export default class ShopUserAvatar extends HTMLElement {
  static observedAttributes = [ATTRIBUTE_SRC, ATTRIBUTE_INITIAL];

  private _wrapperElement?: HTMLElement;
  private _pageImpressionEventEmitted = false;

  constructor() {
    super();

    if (!this.shadowRoot) {
      const shadowRoot = this.attachShadow({mode: 'open'});

      const template = document.createElement('template');
      template.innerHTML = avatarHtml;

      shadowRoot.appendChild(template.content.cloneNode(true));

      this._wrapperElement = shadowRoot.querySelector(
        '.avatar-wrapper',
      ) as HTMLElement;
    }
  }

  connectedCallback() {
    this._emitPageImpressionEvent();
    this._synchronizeCustomProperties();
  }

  attributeChangedCallback(): void {
    this._synchronizeCustomProperties();
  }

  private _synchronizeCustomProperties() {
    const avatarSrc = this.getAttribute(ATTRIBUTE_SRC) || '';
    const initial = this.getAttribute(ATTRIBUTE_INITIAL) || '';

    this._wrapperElement?.style.setProperty(
      '--shop-avatar-initial',
      `"${initial}"`,
    );
    if (avatarSrc) {
      this._wrapperElement?.style.setProperty(
        '--shop-avatar-src',
        `url("${avatarSrc}")`,
      );
    } else {
      this._wrapperElement?.style.removeProperty('--shop-avatar-src');
    }
  }

  private _emitPageImpressionEvent() {
    if (this._pageImpressionEventEmitted) return;

    emitMonorailEventThroughTrekkie({
      schemaId: 'shopify_pay_login_with_shop_sdk_page_impressions/3.3',
      payload: {
        shopPermanentDomain: window.Shopify?.shop || '',
        flow: 'avatar',
        flowVersion: 'unspecified',
        analyticsTraceId: this._getAnalyticsTraceId() || '',
        pageName: 'AVATAR_SHOWN',
      },
    });

    this._pageImpressionEventEmitted = true;
  }

  private _getAnalyticsTraceId() {
    try {
      const value = new RegExp(`(shop_analytics)=([^;]+)`).exec(
        document.cookie,
      );
      return value ? value[2] : null;
    } catch (_ignore) {
      return null;
    }
  }
}

/**
 * Defines the shop-user-avatar custom element.
 */
export function defineElement() {
  // Duplicate implementation from src/__deprecated__/common/init/index.ts, ensures bundle size for avatar is as small as possible.
  if (!window.customElements) return;

  if (!customElements.get('shop-user-avatar')) {
    customElements.define('shop-user-avatar', ShopUserAvatar);
  }
}
